<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>
      Estoque consolidado
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <div class="d-flex">
      <div class="d-flex flex-column" style="flex: 1">
        <span><strong>Filial :</strong>{{ filial?.descricao }}</span>
      </div>
      <div class="d-flex flex-column" style="flex: 1">
        <span><strong>Modelo:</strong> {{ estoqueConsolidadoKit?.data[0]?.modeloKit }}</span>
      </div>
    </div>
    <div *ngIf="isLoading" class="d-flex justify-content-center">
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <mat-divider></mat-divider>
    <div [hidden]="isLoading || estoqueConsolidadoKit?.data?.length === 0">
      <div>
        <table mat-table [dataSource]="estoqueConsolidadoKit" matSort class="table-sm">

          <!-- Situação -->
          <ng-container matColumnDef="situacao">
            <th mat-header-cell *matHeaderCellDef> Situação </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.situacao}} </td>
            <td mat-footer-cell *matFooterCellDef>Total estoque: <strong> {{ statusCount?.cust }} </strong> </td>
          </ng-container>

          <!-- Modelo de Kit -->
          <ng-container matColumnDef="modeloKit">
            <th mat-header-cell *matHeaderCellDef> Modelo de KIT </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.modeloKit}} </td>
            <td mat-footer-cell *matFooterCellDef>Total consolidado: <strong> {{ statusCount?.cons }} </strong></td>
          </ng-container>

          <!-- N. Sequencial -->
          <ng-container matColumnDef="numeroSequencial">
            <th mat-header-cell *matHeaderCellDef> Nº. Sequencial </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.numeroSequencial}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Cód. Barras -->
          <ng-container matColumnDef="codigoBarra">
            <th mat-header-cell *matHeaderCellDef> Código de Barras </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.codigoBarra}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Data de Entrada -->
          <ng-container matColumnDef="dataEntrada">
            <th mat-header-cell *matHeaderCellDef> Data de Entrada </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.dataEntrada}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Data de Entrada -->
          <ng-container matColumnDef="usuarioEntrada">
            <th mat-header-cell *matHeaderCellDef> User de Entrada </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.usuarioEntrada}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Data de Devolução -->
          <ng-container matColumnDef="dataDevolucao">
            <th mat-header-cell *matHeaderCellDef> Data de Devolução </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit">
              {{estoqueConsolidadoKit?.dataDevolucao  | date: 'dd/MM/yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Usuário dev -->
          <ng-container matColumnDef="usuarioDevolucao">
            <th mat-header-cell *matHeaderCellDef> Usuário Dev </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.usuarioDevolucao}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Saída transitória -->
          <ng-container matColumnDef="saidaTransitoria">
            <th mat-header-cell *matHeaderCellDef> Saída transitória </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit"> {{estoqueConsolidadoKit?.saidaTransitoria}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <!-- Ações -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Ação </th>
            <td mat-cell *matCellDef="let estoqueConsolidadoKit">
              <button mat-flat-button color="primary" (click)="openLog(estoqueConsolidadoKit?.prePedidoId)">Log {{ estoqueConsolidadoKit?.prePedidoId }}</button>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsKit"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsKit;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumnsKit"></tr>
        </table>
      </div>
      <app-paginacao [pageIndex]="paging?.index"
        [pageSize]="paging?.size"
        [length]="paging?.length"
        (page)="onPageChange($event)"
        [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
    </div>
    <div *ngIf="!isLoading && estoqueConsolidadoKit?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
      Nenhum registro!
    </div>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close color="primary">OK</button>
  </div>
</div>